<template>

    <div class="restaurant">

        <div class=" start">
            <div class="booking-container" v-if="restaurantConfiguration">

                <div class="page-intro">
                    <h1 v-if="restaurantConfiguration.Heading">{{restaurantConfiguration.Heading}}</h1>
                    <div v-html="restaurantConfiguration.Intro"></div>
                </div>

                <div v-if="!isLoading" class=" mb-5">
                    <div class="row justify-content-center">
                        <div class="mb-5 col-xl-12 d-flex flex-column justify-content-center align-items-center">
                            <iframe v-bind:src="iFramePath"
                                    allowtransparency="true" frameborder="0" style="width:100%; border:none; max-width: 540px; height: 675px; "></iframe>

                            <span class="powered-by">Powered by ResDiary</span>
                        </div>

                    </div>
                    <div v-if="isLoading" class="d-flex justify-content-center">
                        <loader></loader>
                    </div>

                </div>


                <div class="row">
                    <div class="col-24 d-flex justify-content-center">

                        <a href="/" class="btn btn--slate-blue">Rockliffe Home</a>
                    </div>

                </div>
            </div>




        </div>


    </div>

</template>

<script>


    import { store } from '../store/index';

    import Loader from '@/shared/components/Loader.vue';

    export default {
        name: 'RestaurantBooking',
        created() {
       

            this.isLoading = true;
            store.dispatch('clear').then(() => {
                store.dispatch('getConfiguration').then(() => {
                    this.isLoading = false;
                });
            });


        },
        computed: {
            configuration() {
                return store.getters.configuration;
            },
            restaurantConfiguration() {

                if (this.configuration != null) {

                    let id = this.$route.params.id;
                    return this.configuration.Restaurants.find(item => item.Id == id);
                }
                return null;
            },
            iFramePath() {
       

                if (this.restaurantConfiguration?.iFramePath) {
                    let date = this.$route.query.date;
                    let time = this.$route.query.time;


                    let searchParams = new URLSearchParams();
                    if (date) {
                        searchParams.append('date', date);
                    }
                    if (time) {
                        searchParams.append('time', time);
                    }

                    return this.restaurantConfiguration.iFramePath + '?' + searchParams.toString();
                }
                return '';
            }
        },
        components: {

            Loader,
        },
        data() {
            return {
                isLoading: false,

            }
        }
    }
</script>

<style src="@/css/booking/booking.css"></style>
<style>

    .powered-by {
        font-size: 14px;
    }
</style>
